import { render, staticRenderFns } from "./ConfirmApprovalModal.vue?vue&type=template&id=7a491ace&scoped=true"
import script from "./ConfirmApprovalModal.vue?vue&type=script&lang=js"
export * from "./ConfirmApprovalModal.vue?vue&type=script&lang=js"
import style0 from "./ConfirmApprovalModal.vue?vue&type=style&index=0&id=7a491ace&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a491ace",
  null
  
)

export default component.exports